import type { GroupDTO } from '@practium/features/api';
import type { HierarchyDTO, HierarchyLevelDTO } from '@practium/features/api';
import type { ManagementPlanDTO } from '@practium/features/api';
import type { Group, Hierarchy, HierarchyLevel, Plan, SubjectPermission } from '../types';

const formatDate = (value?: string): string =>
	value ? new Date(value).toLocaleDateString('pt-BR') : '';

export const mapGroupDTO = (dto: GroupDTO): Group => ({
	_id: dto._id,
	name: dto.name,
	permissions: dto.permissions as SubjectPermission[],
	hierarchyCount: dto.hierarchyCount,
	createdAt: formatDate(dto.createdAt),
	updatedAt: formatDate(dto.updatedAt),
});

const mapHierarchyLevel = (level: HierarchyLevelDTO): HierarchyLevel => ({
	group:
		level.group && typeof level.group === 'object'
			? { _id: level.group._id, name: level.group.name, permissions: [], createdAt: '', updatedAt: '' }
			: level.group ?? '',
});

export const mapHierarchyDTO = (dto: HierarchyDTO): Hierarchy => ({
	_id: dto._id,
	name: dto.name,
	role: dto.role,
	description: dto.description ?? '',
	farmer: mapHierarchyLevel(dto.farmer),
	consultant: mapHierarchyLevel(dto.consultant),
	company: mapHierarchyLevel(dto.company),
	master: mapHierarchyLevel(dto.master),
});

export const mapManagementPlanDTO = (dto: ManagementPlanDTO): Plan => ({
	_id: dto._id,
	itemId: dto.itemId,
	name: dto.name,
	description: dto.description ?? '',
	hierarchy:
		typeof dto.hierarchy === 'object'
			? {
					_id: dto.hierarchy._id,
					name: dto.hierarchy.name,
					role: '',
					description: '',
					farmer: { group: '' },
					consultant: { group: '' },
					company: { group: '' },
					master: { group: '' },
				}
			: dto.hierarchy,
	status: dto.status,
	paymentMethods: dto.paymentMethods as Plan['paymentMethods'],
	price: dto.price,
	recurrentPayment: dto.recurrentPayment,
	isListable: dto.isListable,
	interval: dto.interval,
	intervalCount: dto.intervalCount,
	gracePeriod: dto.gracePeriod,
	notifyUnpayment: dto.notifyUnpayment,
	notifyInvoice: dto.notifyInvoice,
	maxInstallments: dto.maxInstallments,
	maxProps: dto.maxProps,
	maxSamples: dto.maxSamples,
	monthlyFloraTokens: '',
	paymentLink: '',
	advantages: dto.advantages ?? [],
	subscriberCount: dto.linkedUsers ?? 0,
});
